import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import axios from "axios";
import Loader from "../../../components/Loader/Loader";
import { Link } from "react-router-dom";
import Select from "react-select";
import FeaturedProducts from "../../../components/EcommConfig/FeaturedProducts";
import ClearanceProduct from "../../../components/EcommConfig/ClearanceProduct";
import Banners from "../../../components/EcommConfig/Banners";
import Color from "../../../components/EcommConfig/Color.js";
import Deals from "../../../components/EcommConfig/Deals";
import MainFooter from "../../../components/EcommConfig/MainFooter";
import ClientDetails from "../../../components/EcommConfig/ClientDetails";
import TopCategories from "../../../components/EcommConfig/TopCategories";
import TopBrands from "../../../components/EcommConfig/TopBrands";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
// import Popup from "../../../components/EcommConfig/Popup";
import CommonConfiguration from "../../../components/EcommConfig/Popup";
import DynamicSiteImage from "../../../components/EcommConfig/DynamicSiteImage";
import TopNavigationBar from "../../../components/EcommConfig/TopNavigation";
import TopFooterBar from "../../../components/EcommConfig/TopFooter";
import MainMenuBar from "../../../components/EcommConfig/MainManuBar";
import ReviewList from "../../../components/EcommConfig/ReviewList";

import { faL } from "@fortawesome/free-solid-svg-icons";
import { event } from "jquery";
import config from "../../../config/config.js";

function EcommConfig() {
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const token = localStorage.getItem("Token");
  //For Dropdown
  const [commonConfiguration, setCommonConfiguration] = useState(false);
  const [clientDetails, setClientDetails] = useState(false);
  const [featuredProducts, setFeaturedProducts] = useState(false);
  const [ClearanceProducts, setClearanceProduct] = useState(false);
  const [banners, setBanners] = useState(false);
  const [topCategories, setTopCategories] = useState(false);
  const [topNavigation, setTopNavigation] = useState(false);
  const [TopFooter, setTopFooter] = useState(false);
  const [mainMenu, setMainMenu] = useState(false);
  const [customerReview, setCustomerReview] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [topBrands, settopBrands] = useState(false);
  const [SiteImag, setSiteImage] = useState(false);

  console.log("sssssssssss", selectedOption);

  const optionList = [
    {
      value: "1",
      label: "Common Configuration",
      condition: "COMMONCONFIGURATION",
    },
    { value: "2", label: "Client Details", condition: "CLIENTDETAILS" },
    { value: "3", label: "Featured Products", condition: "FEATUREDPRODUCTS" },
    { value: "4", label: "Banners", condition: "BANNERS" },
    { value: "5", label: "Top Categories", condition: "TOPCATEGORIES" },
    { value: "6", label: "Top Navigation Bar", condition: "TOPNAVIGATIONBAR" },
    { value: "7", label: "Main Menu Bar", condition: "MAINMENUBAR" },
    {
      value: "8",
      label: "Customers Product Review",
      condition: "CUSTOMERREVIEW",
    },
    { value: "9", label: "Top Brands", condition: "TopBrands" },
    { value: "10", label: "Site Image", condition: "SiteImage" },
    // { value: "8", label: "New Arrivals", condition: "NEWARRIVALS" },
    // { value: "9", label: "Hot Selling", condition: "HOTSELLING" },
    // { value: "10", label: "Clearance", condition: "CLEARANCE" },
    // { value: "11", label: "The Most Popular", condition: "THEMOSTPOPULAR" },
  ];

  const optionListDynamicModule = [
    { label: "Main Site", value: "S1" },
    { label: "Second Site", value: "S2" },
    { label: "Third Site", value: "S3" },
  ];

  const [selectedModule, setSelectedModule] = useState([]);
  const [selectedModuleValue, setSelectedModuleValue] = useState(null);

  console.log(selectedModuleValue, "check value selectedModule");
  const handleGetData = () => {
    setLoading(true);

    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getmultisitelist`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;
        console.log(responseData, "check data of dynamic code");
        // Transform for Select options
        const options = responseData.map((item) => ({
          label: item.AppConfigvalue.trim(),
          value: item.AppConfigkey.trim(),
        }));

        setSelectedModule(options);

        // Set default to MainSite
        const defaultOption = options.find(
          (option) => option.value === "MainSite"
        );
        setSelectedModuleValue(defaultOption || null);

        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetData();
  }, []);

  const handleDynamicModuleChange = (selected) => {
    setSelectedModuleValue(selected);
  };

  // Styles
  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "500px",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "500px",
  //   }), // dropdown menu css
  // };

  const CommonConfigurationRef = useRef(null);
  const SiteImageRef = useRef(null);
  const ClientDetailsRef = useRef(null);
  const FeaturedProductsRef = useRef(null);
  const BannersRef = useRef(null);
  const TopCategoriesRef = useRef(null);
  const TopNavigationBarRef = useRef(null);
  const TopFooterBarRef = useRef(null);
  const MainMenuBarRef = useRef(null);
  const CustomerReviewRef = useRef(null);
  const TopBrandsRef = useRef(null);

  const handleStatusDropdown = (event) => {
    if (event && event.condition === "COMMONCONFIGURATION") {
      setCommonConfiguration(true);
      CommonConfigurationRef.current.scrollIntoView({ behavior: "smooth" });
      // window.scrollTo(80, 80);
    } else if (event && event.condition === "CLIENTDETAILS") {
      setClientDetails(true);
      ClientDetailsRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "FEATUREDPRODUCTS") {
      setFeaturedProducts(true);
      FeaturedProductsRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "BANNERS") {
      setBanners(true);
      BannersRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "TOPCATEGORIES") {
      setTopCategories(true);
      TopCategoriesRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "TOPNAVIGATIONBAR") {
      setTopNavigation(true);
      TopNavigationBarRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "TopFooter") {
      setTopFooter(true);
      TopFooterBarRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "MAINMENUBAR") {
      setMainMenu(true);
      MainMenuBarRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "CUSTOMERREVIEW") {
      setCustomerReview(true);
      CustomerReviewRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "TopBrands") {
      settopBrands(true);
      TopBrandsRef.current.scrollIntoView({ behavior: "smooth" });
    }else if (event && event.condition === "SiteImage") {
      setSiteImage(true);
      SiteImageRef.current.scrollIntoView({ behavior: "smooth" });
    } else {
      setCommonConfiguration(false);
      setClientDetails(false);
      setFeaturedProducts(false);
      setBanners(false);
      setTopCategories(false);
      setTopNavigation(false);
      setCustomerReview(false);
      setMainMenu(false);
      settopBrands(false);
      setSiteImage(false);
    }
    setSelectedOption(event);
  };

  //Search Box
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  // console.log("searchQueryyyyyy",searchQuery)
  //For Dropdown
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col"> */}
              {/* <h2 className="page-title">Ecomm Config</h2> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Ecomm Config</li>
              </ul>
              </div>
              </div>
              {/* Sticky search and select bar */}
              <div
                style={{
                  position: "sticky",
                  top: '74px',
                  zIndex: 1000,
                  background: "#fff",
                  padding: "10px",
                  // boxShadow: "0 2px 4px rgba(0,0,0,0.03)",
                  // marginBottom: "60px",
                  backgroundColor:"rgb(233 233 233)",
                  borderRadius:"10px",
                  // marginBottom:"50px"
                }}
                className="d-flex mb-4 ml-2 align-items-center"
              >
                <div className="d-flex card-header">
                  <div className="d-flex flex-wrap">
                  <input
                    type="search"
                    placeholder="Search..."
                    className="search-btn form-control form-control-sm w-100"
                    onChange={handleSearchChange}
                    value={searchQuery}
                    style={{ minWidth: 180 }}
                  />
                </div>
                <div className="ml-2" style={{ minWidth: 220 }}>
                  <Select
                    onChange={(event) => handleStatusDropdown(event)}
                    options={optionList}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    id="Config"
                    name="Config"
                    className="custom-search-select"
                  />
                </div>
                <div className="ml-2" style={{ minWidth: 220 }}>
                  <Select
                    options={selectedModule}
                    value={selectedModuleValue}
                    onChange={handleDynamicModuleChange}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    id="ConfigDynamic"
                    name="ConfigDynamic"
                    className="custom-search-select"
                  />
                </div>
                </div>
              </div>
              {/* CommonConfiguration */}
          <div ref={CommonConfigurationRef}>
            <CommonConfiguration
              visibleCommonChange={commonConfiguration}
              searchQuery={searchQuery}
              dynamicModule={selectedModuleValue?.value}
            />
          </div>
          <div ref={SiteImageRef}>
            <DynamicSiteImage
              visibleCommonChange={SiteImag}
              searchQuery={searchQuery}
              dynamicModule={selectedModuleValue?.value}
            />
          </div>

          {/*Top Navigation Bar*/}
          <div ref={TopNavigationBarRef}>
            <TopNavigationBar
              visibleBannerChange={topNavigation}
              searchQuery={searchQuery}
              dynamicModule={selectedModuleValue?.value}
            />
          </div>
          {/*Top Navigation Bar*/}
          <div ref={TopFooterBarRef}>
            <TopFooterBar
              visibleBannerChange={TopFooter}
              searchQuery={searchQuery}
              dynamicModule={selectedModuleValue?.value}
            />
          </div>

          {/* Main Menu Bar*/}
          <div ref={MainMenuBarRef}>
            <MainMenuBar
              visibleCategoriesChange={mainMenu}
              searchQuery={searchQuery}
              dynamicModule={selectedModuleValue?.value}
            />
          </div>

          {/*Banner*/}
          <div ref={BannersRef}>
            <Banners visibleBannerChange={banners} searchQuery={searchQuery} dynamicModule={selectedModuleValue?.value} />
          </div>

          {/* Top Brands */}
          <div ref={TopBrandsRef}>
            <TopBrands
              visibleBrandChange={topBrands}
              searchQuery={searchQuery}
              dynamicModule={selectedModuleValue?.value}
            />
          </div>

          {/* Top Categories */}
          <div ref={TopCategoriesRef}>
            <TopCategories
              visibleCategoriesChange={topCategories}
              searchQuery={searchQuery}
              dynamicModule={selectedModuleValue?.value}
            />
          </div>

          {/* FeaturedProducts */}
          <div ref={FeaturedProductsRef}>
            <FeaturedProducts
              visibleProductChange={featuredProducts}
              searchQuery={searchQuery}
              dynamicModule={selectedModuleValue?.value}
            />
          </div>

          {/* ClientDetails */}
          {/* <div ref={ClientDetailsRef}>
            <ClientDetails
              visibleClientChange={clientDetails}
              searchQuery={searchQuery}
              dynamicModule={selectedModuleValue?.value}
            />
          </div> */}

          <div ref={FeaturedProductsRef}>
            <ClearanceProduct
              visibleProductChange={featuredProducts}
              searchQuery={searchQuery}
              dynamicModule={selectedModuleValue?.value}
            />
          </div>

          {/* Main Menu Bar*/}
          {/* <div ref={CustomerReviewRef}>
            <ReviewList
              visibleCategoriesChange={customerReview}
              // searchQuery={searchQuery}
              dynamicModule={selectedModuleValue?.value}
            />
          </div> */}

          {/*Deals*/}
          {/* <Deals searchQuery={searchQuery} dynamicModule={selectedModuleValue?.value}/> */}

          {/*Ecommerece Portal Contact Us Details*/}
          <MainFooter searchQuery={searchQuery} dynamicModule={selectedModuleValue?.value}/>

          {/*Theme */}
          <Color searchQuery={searchQuery} dynamicModule={selectedModuleValue?.value} />
        </div>
      </div>
    </>
  );
}

export default EcommConfig;
